import Header from './components/header/header.component';
import GlobalRules from './global-rules';
import DesignPage from './page/design/design.component';
import LandingPage from './page/landing/landing.component';
import ServicesPage from './page/services/services.component';
import PortfolioPage from './page/portfolio/portfolio.component';
import StatsPage from './page/stats/stats.component';
import SkillsPage from './page/skills/skills.component';
import PricingPage from './page/pricing/pricing.component';
import ContactPage from './page/contact/contact.component';
import Footer from './components/footer/footer.component';

function App() {
    return (
        <div>
            <GlobalRules />
            <Header />
            <LandingPage />
            <ServicesPage />
            <DesignPage />
            <PortfolioPage />
            <StatsPage />
            <SkillsPage />
            <PricingPage />
            <ContactPage />
            <Footer />
        </div>
    );
}

export default App;
